/* import __COLOCATED_TEMPLATE__ from './saml-providers.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';
import { inject as service } from '@ember/service';

const CLASS_NAME = 'SH-c-saml-providers';

class SamlProvidersComponent extends Component {

  @service session;

  get className() {
    return CLASS_NAME;
  }

  get classNames() {
    return clsx(
      CLASS_NAME,
      this.args.class,
    );
  }

  get samlProvidersLoading() {
    return this.args.samlProviders == null;
  }

  get samlName() {
    return this.session.currentUser?.company.name
      ? `SAML - ${this.session.currentUser.company.name}`
      : 'SAML';
  }
}

export default SamlProvidersComponent;
